import { Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation, ElementRef, ChangeDetectorRef, AfterViewChecked, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonDialogComponent } from 'app/components/common-dialog/common-dialog.component';
import { TimeLineDataService } from 'app/components/time-line/time-line-data.service';
import { AuthenticationService } from 'app/services';
import { BaseService } from 'app/_helpers/base/base.service';
import { isEmpty, ceil, unionBy } from 'lodash';
import { FiltersComponent } from '../../filters/filters.component';
import { merge, Subject } from 'rxjs';
import { startWith, tap, takeUntil, switchMap } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { QuickEditComponent } from 'app/main/master-data/accounts/quick-edit/quick-edit.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TasksCreateModalComponent } from 'app/main/activities/tasks/tasks-create-modal/tasks-create-modal.component';

@Component({
  selector: 'app-wg-actionable-accounts',
  templateUrl: './wg-actionable-accounts.component.html',
  styleUrls: ['./wg-actionable-accounts.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class WgActionableAccountsComponent implements OnInit, AfterViewChecked, OnDestroy  {

  user: any;
  loadingData = true as boolean;
  accountsData: any = {};
  @Output() openProperties: EventEmitter<any>;
  private _unsubscribeAll: Subject<any> = new Subject();
  sort = {} as any;
  searchDialogRef: any;
  searchFilters = {} as any;
  reload: EventEmitter<any> = new EventEmitter();
  acAccountsSort: UntypedFormControl = new UntypedFormControl('nameAZ');
  searchSave: any;
  accountsWidgetChecked: boolean;
  @ViewChild('accountsWidget', { static: false }) private accountsWidget: ElementRef;
  accountsDataPage: UntypedFormControl = new UntypedFormControl(1);

  constructor(
    private _authenticationService: AuthenticationService,
    private _gService: BaseService,
    private _timeLineData: TimeLineDataService,
    private _fuseSidebarService: FuseSidebarService,
    private _matDialog: MatDialog,
    private _translateService: TranslateService,
    private _snackBar: MatSnackBar,
    private cdRef: ChangeDetectorRef,

  ) {
    this.user = this._authenticationService.currentUserValue;
    this.openProperties = new EventEmitter();
    this.accountsWidgetChecked = false;
  }

  ngOnInit(): void {
    merge(this.acAccountsSort.valueChanges, this.accountsDataPage.valueChanges, this.reload)
      .pipe(
        startWith(''),
        tap(() => this.loadingData = true),
        takeUntil(this._unsubscribeAll),
        switchMap((change: string | number) => {
          if (this.acAccountsSort.value) {
            this.sort = {};
            if (this.acAccountsSort.value === 'nameAZ') {
              this.sort = { 'account_data.full_name': 1 };
            } else if (this.acAccountsSort.value === 'nameZA') {
              this.sort = { 'account_data.full_name': -1 };
            } else if (this.acAccountsSort.value === 'updateAZ') {
              this.sort = { 'account_data.updated_at': 1 };
            } else if (this.acAccountsSort.value === 'updateZA') {
              this.sort = { 'account_data.updated_at': -1 };
            }
            if (this.sort) {
              this.searchFilters.sort = this.sort;
            }
          }
          if (typeof change === 'string') {
            this.accountsDataPage.setValue(1, { emitEvent: false });
            if (this.accountsWidget) {
              this.accountsWidget.nativeElement.scrollTop = 0;
            }
          }
          this.searchFilters.options = {
            page: this.accountsDataPage.value, limit: 10
          }
          return this._gService.post(`dashboard/actionable_accounts`, this.searchFilters, 'nodejs');
        })
      )
      .subscribe((data: any) => {
        if (!this.accountsData.docs || this.accountsDataPage.value === 1) {
          this.accountsData = data;
        } else {
          this.accountsData.docs = unionBy(this.accountsData.docs, data.docs, '_id');
        }
        this.loadingData = false;
      }, () => this.loadingData = false);
  }
  
  addTasks(event: any, id?: string, name?: string): void {
    let data = {};
    data = {
      relatedTo: 'accounts',
      accountId: id,
      accountName: name,
    };
    this.searchDialogRef = this._matDialog.open(
      TasksCreateModalComponent,
      {
        panelClass: 'event-form-dialog',
        data: data,
      }
    );
    this.searchDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.reload.next(true);
      }
    });
  }
  openTimeline(account: any): void {
    this._timeLineData.setModelDataValue(account);
    this._timeLineData.setRelatedToValue('account');
    this._fuseSidebarService.getSidebar('timeline').toggleOpen();
  }

  openCommonDialog(data: any, type: string): any {
    const relatedTo = 'account';
    if (((data.work_phone) && data.work_phone !== '') ||
      ((data.home_phone) && data.home_phone !== '') ||
      ((data.mobile_phone) && data.mobile_phone !== '') ||
      ((data.mobile) && data.mobile !== '')) {
      const mobileData = {
        type: relatedTo,
        _id: data._id,
        mobile: relatedTo === 'account' ? data.mobile_phone : data.mobile,
        homePhone: data.home_phone,
        workPhone: data.work_phone,
      };
      const dialog = this._matDialog.open(CommonDialogComponent, {
        disableClose: false,
        panelClass: 'common-dialog',
        data: mobileData
      });
    }
  }

  // sortActionableAccounts(): void {
  //   this.sort = { 'account_data.full_name': (!this.sort['account_data.full_name'] || this.sort['account_data.full_name'] === -1 ? 1 : -1) };
  //   this.searchFilters.sort = this.sort;
  //   this.actionableAccounts();
  // }

  openFilterModal(): void {
    this.searchDialogRef = this._matDialog.open(FiltersComponent, {
      panelClass: 'event-form-dialog',
     data: {
       data: this.searchSave ? this.searchSave : {},
       from: 'actionableAccounts'
     }
    });
    this.searchDialogRef.afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        if (response) {
          this.searchFilters = {};
          this.searchSave = response;
          this.searchFilters = response;
          this.reload.next(true);
        }
      });
  }

  updateData(data: any, tab: string): void {
    const dialogRef = this._matDialog.open(QuickEditComponent, {
      disableClose: false,
      panelClass: 'event-form-dialog',
      data: {
        tab: tab,
        account: data
      },
    });
    dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.reload.next(true);
          this._snackBar.open(this._translateService.instant('Updated successfully'), this._translateService.instant('Close'), {
            duration: 2000,
          });
        }
      });
  }

  ngAfterViewChecked(): void {
    if (!this.accountsWidgetChecked && this.accountsWidget) {
      this.accountsWidget.nativeElement
        .addEventListener('scroll', (event: any) => this.widgetScroll(event, this.accountsDataPage, this.accountsData), true);
      this.accountsWidgetChecked = true;
    }
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.accountsWidget && this.accountsWidget.nativeElement) {
      this.accountsWidget.nativeElement
        .removeEventListener('scroll', (event: any) => this.widgetScroll(event, this.accountsDataPage, this.accountsData), true);
    }
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  widgetScroll(event: any, dataPage: UntypedFormControl, data: any): void {
    if (event.target.scrollTop + event.target.clientHeight <= event.target.scrollHeight && dataPage.value < ceil(data.total / data.limit)) {
      dataPage.setValue(dataPage.value + 1);
    }
  }

}
